export default __webpack_public_path__ + "static/invisible-c429a86ba315a69bee2f2fbbb739b5d4.png";